// extracted by mini-css-extract-plugin
export default {"tier_verification":"aA","verification_items":"bA","block_title":"cA","reg":"eA","blue":"fA","verification_item":"gA","title":"hA"};
    if(module.hot) {
      // 1713211520675
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  